import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-xs" }

import { computed, PropType } from "vue";
import { Transaction } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'TransactionBadge',
  props: {
  transaction: {
    type: Object as PropType<Transaction>,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const type = computed(() => {
  let c = "";

  switch (props.transaction.status.toLowerCase()) {
    case "confirmed":
      c = "bg-green-500";
      break;
    case "complete":
      c = "bg-green-500";
      break;
    case "pending":
      c = "bg-warning";
      break;
    case "abandoned":
      c = "bg-red-500";
      break;
    case "failed":
      c = "bg-red-500";
      break;
    default:
      c = "bg-grey-500";
      break;
  }

  return c;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_unref(type), 'flex items-center space-x-2 p-1 rounded-full text-white capitalize w-fit'])
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t(props.transaction.status.toLowerCase())), 1)
  ], 2))
}
}

})